import React from "react"
import PropTypes from "prop-types"

const Phone = ({ fillColor }) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_20_90)">
      <path
        d="M14.5916 11.0085L12.4983 8.91519C11.7507 8.16759 10.4798 8.46666 10.1807 9.43852C9.95646 10.1114 9.20885 10.4852 8.53601 10.3356C7.0408 9.96184 5.02227 8.01807 4.64846 6.4481C4.42418 5.77522 4.87274 5.02762 5.54559 4.80336C6.51748 4.50432 6.81652 3.23339 6.06891 2.48579L3.97562 0.392493C3.37754 -0.130831 2.48041 -0.130831 1.95709 0.392493L0.536636 1.81294C-0.883813 3.30815 0.686157 7.27046 4.1999 10.7842C7.71364 14.298 11.676 15.9427 13.1712 14.4475L14.5916 13.027C15.115 12.4289 15.115 11.5318 14.5916 11.0085Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_20_90">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

Phone.propsTypes = {
  fillColor: PropTypes.string,
}

Phone.defaultProps = {
  fillColor: "currentColor",
}

export { Phone }
